var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCustomUnfoldMore(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -960 960 960",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M308-623q-14-14-14-33.5t14-33.5l139-139q7-8 15.5-11.5T480-844q9 0 17.5 3.5T513-829l139 138q14 14 14 34t-14 34q-14 14-33.5 14T585-623L480-727 376-623q-14 14-34 14t-34-14Zm172 508q-9 0-17.5-3.5T447-129L308-268q-14-14-14-33.5t14-34.5q14-14 33.5-14t33.5 14l105 105 104-105q14-14 34-14t34 14q14 15 14 34.5T652-268L513-129q-7 7-15.5 10.5T480-115Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomUnfoldMore);
export default __webpack_public_path__ + "static/media/custom-unfold-more.3170e1a66ac35dc904d653c4db3219b6.svg";
export { ForwardRef as ReactComponent };